import React, { useState, useEffect } from 'react';
import smsService from '../../services/smsService';
import userService from '../../services/userService';
import '../../styles/Admin.css';

const SMSManagement = () => {
  const [sendType, setSendType] = useState('single');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneNumbers, setPhoneNumbers] = useState('');
  const [selectedModule, setSelectedModule] = useState('ARA');
  const [message, setMessage] = useState('');
  const [users, setUsers] = useState([]);
  const [responseMessage, setResponseMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const data = await userService.getAllUsers();
      setUsers(data.users);
    } catch (err) {
      setError('Erreur lors du chargement des utilisateurs');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setResponseMessage('');
    setLoading(true);

    try {
      let result;

      if (sendType === 'single') {
        result = await smsService.sendSMS(phoneNumber, message);
        setResponseMessage('SMS envoyé avec succès');
      } else if (sendType === 'bulk') {
        const numbers = phoneNumbers.split(',').map((n) => n.trim());
        result = await smsService.sendBulkSMS(numbers, message);
        setResponseMessage(
          `SMS envoyé à ${result.summary.success}/${result.summary.total} destinataires`
        );
      } else if (sendType === 'module') {
        result = await smsService.sendSMSToModule(selectedModule, message);
        setResponseMessage(
          `SMS envoyé à ${result.summary.success}/${result.summary.total} utilisateurs du module ${selectedModule}`
        );
      }

      // Réinitialiser le formulaire
      setPhoneNumber('');
      setPhoneNumbers('');
      setMessage('');
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur lors de l\'envoi du SMS');
    }

    setLoading(false);
  };

  const moduleUsers = users.filter((user) => user.module === selectedModule);

  return (
    <div className="sms-management">
      <h1>Gestion des SMS</h1>

      {responseMessage && <div className="success-message">{responseMessage}</div>}
      {error && <div className="error-message">{error}</div>}

      <div className="sms-form-container">
        <div className="send-type-selector">
          <button
            className={`type-btn ${sendType === 'single' ? 'active' : ''}`}
            onClick={() => setSendType('single')}
          >
            SMS unique
          </button>
          <button
            className={`type-btn ${sendType === 'bulk' ? 'active' : ''}`}
            onClick={() => setSendType('bulk')}
          >
            SMS groupé
          </button>
          <button
            className={`type-btn ${sendType === 'module' ? 'active' : ''}`}
            onClick={() => setSendType('module')}
          >
            SMS par module
          </button>
        </div>

        <form onSubmit={handleSubmit} className="sms-form">
          {sendType === 'single' && (
            <div className="form-group">
              <label>Numéro de téléphone</label>
              <input
                type="tel"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="+225070000000"
                required
                disabled={loading}
              />
            </div>
          )}

          {sendType === 'bulk' && (
            <div className="form-group">
              <label>Numéros de téléphone (séparés par des virgules)</label>
              <textarea
                value={phoneNumbers}
                onChange={(e) => setPhoneNumbers(e.target.value)}
                placeholder="+225070000001, +225070000002, +225070000003"
                rows="3"
                required
                disabled={loading}
              />
            </div>
          )}

          {sendType === 'module' && (
            <div className="form-group">
              <label>Module</label>
              <select
                value={selectedModule}
                onChange={(e) => setSelectedModule(e.target.value)}
                required
                disabled={loading}
              >
                <option value="ARA">ARA</option>
                <option value="ESSIE-EHOUN">ESSIE-EHOUN</option>
              </select>
              <p className="helper-text">
                {moduleUsers.length} utilisateur(s) dans ce module
              </p>
            </div>
          )}

          <div className="form-group">
            <label>Message</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Votre message..."
              rows="5"
              required
              disabled={loading}
            />
            <p className="helper-text">{message.length} caractères</p>
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Envoi en cours...' : 'Envoyer'}
          </button>
        </form>
      </div>

      {sendType === 'module' && (
        <div className="users-preview">
          <h3>Utilisateurs du module {selectedModule}</h3>
          <table className="users-table">
            <thead>
              <tr>
                <th>Nom</th>
                <th>Email</th>
                <th>Téléphone</th>
              </tr>
            </thead>
            <tbody>
              {moduleUsers.map((user) => (
                <tr key={user.id}>
                  <td>{user.username}</td>
                  <td>{user.email}</td>
                  <td>{user.phone}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SMSManagement;
